import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { NGXLogger } from "ngx-logger";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService  {

    constructor(private http: HttpService, private logger: NGXLogger, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>  {
        return new Promise<boolean>((resolve, reject) => {
            let url: string = `/admin/canactivate?path=${route.routeConfig.path}`;
            this.http.getFromApi(url).subscribe(
                result => {
                    this.logger.trace('Canactivate:',[result]);
                    if(!result){
                        this.router.navigate(['/']);  
                    }

                    resolve(result);
                },
                error => {
                    this.logger.warn('Canactivate error:',[error]);
                    this.router.navigate(['/']);
                    resolve(false);
                  })
        });
    };

}